var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeftIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 34,
    viewBox: "0 0 21 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84033 17.8857L19.2763 28.3207C19.5723 28.6159 19.8071 28.9666 19.9673 29.3527C20.1275 29.7388 20.21 30.1527 20.21 30.5707C20.21 30.9887 20.1275 31.4027 19.9673 31.7887C19.8071 32.1748 19.5723 32.5255 19.2763 32.8207L19.2303 32.8667C18.6344 33.4626 17.8261 33.7974 16.9833 33.7974C16.1406 33.7974 15.3323 33.4626 14.7363 32.8667L1.15033 19.2767C0.546942 18.6728 0.20801 17.854 0.20801 17.0002C0.20801 16.1465 0.546942 15.3277 1.15033 14.7237L14.7363 1.13673C15.3323 0.540856 16.1406 0.206104 16.9833 0.206104C17.8261 0.206104 18.6344 0.540856 19.2303 1.13673L19.2763 1.18273C19.5716 1.4777 19.8059 1.82797 19.9657 2.21353C20.1255 2.59908 20.2078 3.01236 20.2078 3.42973C20.2078 3.8471 20.1255 4.26038 19.9657 4.64594C19.8059 5.0315 19.5716 5.38177 19.2763 5.67673L8.84033 16.1137C8.72386 16.23 8.63146 16.3681 8.56842 16.5202C8.50537 16.6722 8.47292 16.8352 8.47292 16.9997C8.47292 17.1643 8.50537 17.3273 8.56842 17.4793C8.63146 17.6313 8.72386 17.7694 8.84033 17.8857Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftIcon);
export default __webpack_public_path__ + "static/media/arrow-left-icon.f58ea830.svg";
export { ForwardRef as ReactComponent };